import { Injector } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UiEngineComponent } from 'src/modules/base/components/ui-engine/ui-engine.component';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-finance-component',
    templateUrl: './finance-component.component.html',
    styleUrls: ['./finance-component.component.scss'],
    standalone: false
})
export class FinanceComponentComponent extends UiEngineComponent implements OnInit {

  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService
  ) {
    super(injector, router, route, modal)
  }
  ngOnInit() {
    this.resourcename = 'ot_finance_surgery';
    if (this.route.snapshot.data['resource'] == 'ot_finance_format_op') {
      this.resourcename = 'ot_finance_surgery_op';
    }
    if (this.route.snapshot.queryParams['tab_0']) {
      this.resourcename = this.route.snapshot.queryParams['tab_0']
    }
    super.ngOnInit();
  }

  getFilter() {
    this._currentData.gridData['filter'] = '';
    if (this.route.snapshot.data['resource'] == 'ot_finance_format') {
      this._currentData.gridData['filter'] = "patientType:IP"
    }
    else if (this.route.snapshot.data['resource'] == 'ot_finance_format_er') {
      this._currentData.gridData['filter'] = "patientType:ER"
    }
    else if (this.route.snapshot.data['resource'] == 'ot_finance_format_dc') {
      this._currentData.gridData['filter'] = "patientType:DC"
    }
    else if (this.route.snapshot.data['resource'] == 'ot_finance_format_op') {
      this._currentData.gridData['filter'] = "patientType:OP"
    }
    else {
      this.checkFilterConditions();
    }
  }
  customRoute(action, key) {
    //this will work as new capability
    if (action.route_path != undefined && action.route_path) {
      //here key is the data of the row
      this.baseService.redirectToOtherPage(action.route_path, key);
    }
    else {
      //console.log("Key ", action, key);
      var app = '';
      if (action.hasOwnProperty('application')) {
        app = action.application;
      } else {
        app = this.appService.getApplication();
      }
      var keyForUrl = '';
      if (action.hasOwnProperty('redirectLink') && (action.redirectLink == "billing_format_ip/billingDesign" || action.redirectLink == "billing_format_ip/billingDesignviewdetails")) {
        if (action.hasOwnProperty('get_key')) {
          keyForUrl = this.route.snapshot.queryParams.key;
        } else {
          if (action.set_key != undefined && action.set_key != '') {
            keyForUrl = key[action.set_key];
          } else {
            let args = "uhId:" + key.uhId + ",encounter_id:" + key.encounter_id;
            this.baseService.get("GET_BILLING_DETAIL_ID", args, "surgery_request", "ot").subscribe((data: any) => {
              if (data.resource.length) {
                console.log(data);
                keyForUrl = data.resource[0].id ? data.resource[0].id : key;//change by saurav deep for getting key
                let queryParams = { key: keyForUrl };
                let returnUrl = { returnUrl: this.router.url };
                queryParams = { ...queryParams, ...returnUrl }
                console.log("query Params is ", queryParams);
                let url = '';
                if (action.hasOwnProperty('redirectLink')) {
                  action.redirectLink = action.redirectLink.indexOf('!!!') != -1 ? this.baseService.buildDyanamicStr(action.redirectLink, { data: key }) : action.redirectLink;
                  url = '/' + app + '/' + action.redirectLink;
                  if (action.hasOwnProperty('queryParams')) {
                    this.router.navigate([url], {
                      queryParams: queryParams
                    });
                  } else {
                    this.router.navigate([url], { queryParams: queryParams });
                  }
                }
              }
            });
          }
        }
      }
      if (action.hasOwnProperty('redirectLink') && action.redirectLink == "/opbilling/viewdetail") {
        if (action.hasOwnProperty('get_key')) {
          keyForUrl = this.route.snapshot.queryParams.key;
        } else {
          if (action.set_key != undefined && action.set_key != '') {
            keyForUrl = key[action.set_key];
          } else {
            let args = "uhId:" + key.uhId;
            this.baseService.get("GET_BOOKED_ORDER_DETAILS", args, "surgery_request", "ot").subscribe((data: any) => {
              if (data.resource.length) {
                console.log(data);
                keyForUrl = data.resource[0].id ? data.resource[0].id : key;//change by saurav deep for getting key
                let queryParams = { key: keyForUrl };
                //  let returnUrl = { returnUrl: this.router.url };
                if (action.hasOwnProperty('queryParams')) {
                  let banner = { banner: JSON.stringify(action.queryParams) }
                  queryParams = { ...queryParams, ...banner, ...{ returnUrl: this.router.url } }
                }
                console.log("query Params is ", queryParams);
                let url = '';
                if (action.hasOwnProperty('redirectLink')) {
                  action.redirectLink = action.redirectLink.indexOf('!!!') != -1 ? this.baseService.buildDyanamicStr(action.redirectLink, { data: key }) : action.redirectLink;
                  url = '/' + app + '/' + action.redirectLink;
                  if (action.hasOwnProperty('queryParams')) {
                    this.router.navigate([url], {
                      queryParams: queryParams
                    });
                  } else {
                    this.router.navigate([url], { queryParams: queryParams });
                  }
                }
              }
              else {
                this.alerts.error("Data Not Found");
              }
            });
          }
        }
      }
      if (action.redirectLink == undefined || (action.redirectLink != "billing_format_ip/billingDesign" && action.redirectLink != "billing_format_ip/billingDesignviewdetails" && action.redirectLink != "/opbilling/viewdetail")) {
        if (action.hasOwnProperty('get_key')) {
          keyForUrl = this.route.snapshot.queryParams.key;
        } else {
          if (action.set_key != undefined && action.set_key != '') {
            let args = "uhId:" + key.uhId + ",encounter_id:" + key.encounter_id;
            this.baseService.get("GET_BILLING_DETAIL_ID", args, "surgery_request", "ot").subscribe((data: any) => {
              if (data.resource.length) {
                keyForUrl = data.resource[0].id ? data.resource[0].id : key
                let queryParams = { key: keyForUrl };
                let returnUrl = { returnUrl: this.router.url };
                queryParams = { ...queryParams, ...returnUrl }
                let url = '';
                if (action.hasOwnProperty('redirect') && action.redirect.action != undefined) {
                  if (action.redirect.action == 'modify' || action.redirect.action == 'view') {
                    url = '/' + app + '/' + action.resource + '/' + key.id + '/' + action.redirect.action;
                    if (action.hasOwnProperty('queryParams')) {
                      this.router.navigate([url], { queryParams: queryParams });
                    } else {
                      this.router.navigate([url], { queryParams: queryParams });
                    }
                  } else if (action.redirect.action == 'list') {
                    url = '/' + app + '/' + action.resource + '/' + action.redirect.action;
                    if (action.hasOwnProperty('queryParams')) {
                      this.router.navigate([url], { queryParams: queryParams });
                    } else {
                      this.router.navigate([url], { queryParams: queryParams });
                    }
                  } else {
                    url = '/' + app + '/' + action.resource + '/' + action.redirect.action;
                    if (action.hasOwnProperty('queryParams')) {
                      this.router.navigate([url], { queryParams: queryParams });
                    } else {
                      this.router.navigate([url], { queryParams: queryParams });
                    }
                  }
                }
              }
            })
          } else {
            keyForUrl = key.id ? key.id : key;//change by saurav deep for getting key
            let queryParams = { key: keyForUrl };
            if (action.hasOwnProperty('query_params')) {
              let query_params = this.baseService.buildDyanamicStr(action.query_params, { data: key });
              queryParams = { ...queryParams, ...{ query_params } }
            }
            if (action.hasOwnProperty('queryParams')) {
              let banner = { banner: JSON.stringify(action.queryParams) }
              queryParams = { ...queryParams, ...banner, ...{ returnUrl: this.router.url } }
            } else {
              let returnUrl = { returnUrl: this.router.url };
              queryParams = { ...queryParams, ...returnUrl }
            }
            console.log("query Params is ", queryParams);
            let url = '';
            if (action.hasOwnProperty('redirect') && action.redirect.action != undefined) {
              if (action.redirect.action == 'modify' || action.redirect.action == 'view') {
                url = '/' + app + '/' + action.resource + '/' + key.id + '/' + action.redirect.action;
                if (action.hasOwnProperty('queryParams')) {
                  this.router.navigate([url], { queryParams: queryParams });
                } else {
                  this.router.navigate([url], { queryParams: queryParams });
                }
              } else if (action.redirect.action == 'list') {
                url = '/' + app + '/' + action.resource + '/' + action.redirect.action;
                if (action.hasOwnProperty('queryParams')) {
                  this.router.navigate([url], { queryParams: queryParams });
                } else {
                  this.router.navigate([url], { queryParams: queryParams });
                }
              } else {
                url = '/' + app + '/' + action.resource + '/' + action.redirect.action;
                if (action.hasOwnProperty('queryParams')) {
                  this.router.navigate([url], { queryParams: queryParams });
                } else {
                  this.router.navigate([url], { queryParams: queryParams });
                }
              }
            }
            else if (action.hasOwnProperty('redirectLink')) {
              action.redirectLink = action.redirectLink.indexOf('!!!') != -1 ? this.baseService.buildDyanamicStr(action.redirectLink, { data: key }) : action.redirectLink;
              url = '/' + app + '/' + action.redirectLink;
              if (action.hasOwnProperty('queryParams')) {
                this.router.navigate([url], {
                  queryParams: queryParams
                });
              } else {
                this.router.navigate([url], { queryParams: queryParams });
              }
            } else {
              if (action.dependent != undefined && action.dependent) {
                if (localStorage.getItem('filterValueInForm') == null) {
                  alert("Select filter first");
                }
                else {
                  let a = action.key ? key[action.key] : keyForUrl;
                  url = '/' + app + '/' + keyForUrl + '/' + action.resource + '/' + (action.type ? action.type : '');
                  this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: a } });
                }
              }
              else {
                let c = action.key ? key[action.key] : keyForUrl;
                url = '/' + app + '/' + encodeURIComponent(c) + '/' + action.resource + '/' + (action.type ? action.type : '');
                if (action.hasOwnProperty('queryParams') || action.hasOwnProperty('query_params')) {
                  let b = action.key ? key[action.key] : keyForUrl;
                  if (action.hasOwnProperty('query_params')) {
                    let query_params = this.baseService.buildDyanamicStr(action.query_params, { data: key });
                    this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: b, data: JSON.stringify(action.queryParams), query_params: query_params } });
                  } else {
                    this.router.navigate([url], { queryParams: { returnUrl: this.router.url, key: b, data: JSON.stringify(action.queryParams) } });
                  }
                } else if (action.hasOwnProperty('new_tab')) {
                  //saurav deep for opening video on pop up

                  var teleService = this.baseService.getTeleService();
                  if (teleService != undefined) {
                    //key_to_send, key_to_show needs to be removed
                    url = '/' + action['action_name'] + '/' + action['application']
                    teleService.initCallData(this.getValue(key, action, "key_to_send"), this.getValue(key, action, "key_to_show"), this.getValue(key, action, "channel_id"), this.getValue(key, action, "order_id"), action, key, () => {
                      if (this._currentData.resouceDef.list.hasOwnProperty('APIresource')) {
                        this.bindGrid(this._currentData.APIresource.resource, this._currentData.APIresource.application, '', this._currentData.APIresource.query_id);
                      } else {
                        this.bindGrid();
                      }
                    });
                  }
                } else
                  this.router.navigate([url], { queryParams: queryParams });
              }
            }
          }
        }
      }
    }
  }

}
